import { IPoliticalPartyAddEditRequest } from '../../../../model/sge/political-party/request/political-party-add-edit-request';

export type PoliticalPartyCreateEditState = {
    partyId?: string;
    partyRequest: IPoliticalPartyAddEditRequest;
    showValidationErrors: boolean;
};

export enum ACTION_TYPES {
    setPartyId = 'setPartyId',
    setPartyRequest = 'setPartyRequest',
    updatePartyRequest = 'updatePartyRequest',
    setShowValidationErrors = 'setShowValidationErrors',
}

export const PoliticalPartyCreateEditReducer = (state: PoliticalPartyCreateEditState, action: any): PoliticalPartyCreateEditState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setPartyId:
            return { ...state, partyId: payload };
        case ACTION_TYPES.setPartyRequest:
            return { ...state, partyRequest: payload };
        case ACTION_TYPES.updatePartyRequest:
            return { ...state, partyRequest: { ...state.partyRequest, ...payload } };
        case ACTION_TYPES.setShowValidationErrors:
            return { ...state, showValidationErrors: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
